import { Component, input } from '@angular/core';
import { LucideDynamicIcon, LucideShieldCheck } from '@lucide/angular';
import { TextDirective } from '../../../typography/text.directive';

export type InsuranceBadgeType = 'insured-with' | 'mini';

export const InsuranceBrands = {
  AFI: 'AFI',
  Waggel: 'Waggel',
  Asda: 'Asda',
  PurelyPets: 'PurelyPets',
} as const;

@Component({
  selector: 'joii-insurance-badge',
  template: `
    <svg [lucideIcon]="icon" [strokeWidth]="2" [size]="16" />
    <div>
      @if (type() === 'insured-with') {
        <span joii-text [size]="3" color="positive">Insured with&nbsp;</span>
      }
      <span joii-text [size]="3" weight="semibold" class="insurance-text">{{ insurer() }}</span>
    </div>
  `,
  imports: [TextDirective, LucideDynamicIcon],
  host: {
    '[attr.data-badge-type]': 'type()',
    '[attr.data-insurer]': 'insurer()',
  },
  styles: `
    :host {
      border-radius: var(--Vetai-Radius-2);
      padding: var(--Vetai-Spacing-1-5) var(--Vetai-Spacing-2);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background-color: var(--Vetai-Negative_package--Default);
      gap: var(--Vetai-Spacing-1);
    }
    :host[data-insurer='AFI'] .insurance-text {
      color: var(--Vetai-Brands--AFI--Default) !important;
    }
    :host[data-insurer='Waggel'] .insurance-text {
      color: var(--Vetai-Brands--Waggel--Default) !important;
    }
    :host[data-insurer='Asda'] .insurance-text {
      color: var(--Vetai-Brands--Asda--Default) !important;
    }
    :host[data-insurer='PurelyPets'] .insurance-text {
      color: var(--Vetai-Brands--Purely-Pets--Default) !important;
    }
    :host[data-badge-type='insured-with'] svg.lucide {
      color: var(--Vetai-Positive_package--Default);
    }
    :host[data-badge-type='mini'][data-insurer='AFI'] svg.lucide {
      color: var(--Vetai-Brands--AFI--Default);
    }
    :host[data-badge-type='mini'][data-insurer='Waggel'] svg.lucide {
      color: var(--Vetai-Brands--Waggel--Default);
    }
    :host[data-badge-type='mini'][data-insurer='Asda'] svg.lucide {
      color: var(--Vetai-Brands--Asda--Default);
    }
    :host[data-badge-type='mini'][data-insurer='PurelyPets'] svg.lucide {
      color: var(--Vetai-Brands--Purely-Pets--Default);
    }
  `,
})
export class InsuranceBadgeComponent {
  type = input<InsuranceBadgeType>('insured-with');
  insurer = input<keyof typeof InsuranceBrands>(InsuranceBrands.AFI);
  icon = LucideShieldCheck;
}
